

export const getFilePath = (file: File): string => {
	// new versions of browsers do not show `path` property
	// @ts-ignore
	return file.hasOwnProperty("path") ? file.path : file.name;
}